/*
 * @Descripttion: 
 * @Author: panyufeng
 * @Date: 2024-06-14 15:36:51
 * @LastEditors: panyufeng
 * @LastEditTime: 2025-04-10 15:33:52
 */
import service from '@/utils/request'

// 列表
export const auditLogAPI = (params: any) =>
  service.request({
    method: 'post',
    url: '/admin/auditLog/page',
    data: params
  })

// 公司uuid
export const dropdownOfEnterprise = (params: any) =>
  service.request({
    method: 'post',
    url: 'admin/enterprise/dropdownOfEnterprise',
    data: params
  })
